import { VirtualCardType } from 'modules/virtual-cards/constants'

import { VcnManagementAction } from './vcn-bulk-upload-preview.dto'

/** Payload for `POST /vcn/bulk-execute`. */
export interface VcnBulkExecuteItem {
  benefit_id: string
  vcn_token?: string
  action: VcnManagementAction
  /** Provider for created cards; backend defaults to WEX when omitted. */
  provider?: VirtualCardType
}

export interface VcnBulkExecuteRequest {
  items: VcnBulkExecuteItem[]
}

export interface VcnBulkExecuteResponse {
  jobId?: string
  submittedCount: number
  message?: string
}

export interface VcnBulkExecuteConflictBody {
  message: string
  jobId: string
}

export class VcnBulkExecuteConflictError extends Error {
  readonly jobId: string

  constructor(body: VcnBulkExecuteConflictBody) {
    super(body.message)
    this.name = 'VcnBulkExecuteConflictError'
    this.jobId = body.jobId
  }
}
